@if (file) {
    <div (click)="thumbnailClick(audioElement, state)" (keyup.enter)="thumbnailClick(audioElement, state)"
         [class.playing]="state == 'play'" class="sound-wave">
        @for (bar of waveform; track bar) {
            <div [style.animation-duration]="bar.delay" [style.width]="width" class="bar"></div>
        }
    </div>
    <audio #audioElement (contextmenu)="false" (pause)="this.state = 'paused'" (play)="this.state = 'play'"
           [preload]="small ? 'none' : 'auto'" [src]="file" [tabIndex]="small ? -1: -1"
           class="w-100" controls controlsList="nodownload noplaybackrate">
        Your browser does not support the audio tag.
    </audio>
}
@if (!file) {
    <div class="d-flex justify-content-center">
        <mat-progress-spinner color="accent" mode="indeterminate"></mat-progress-spinner>
    </div>
}
